import React from "react";
import { Image } from "../Image/Image";
import { Tag, TagLabel } from "../Tag/Tag";

export type CategoryKey =
  | "animals"
  | "diy"
  | "gardening"
  | "babysitting"
  | "housekeeping"
  | "it"
  | "support"
  | "transporter"
  | "well-being"
  | "events";

interface CategoryPillProps {
  /** Category key used to resolve the icon SVG and translation. */
  categoryKey: CategoryKey;
  /** Optional label override. Falls back to the translated category name. */
  name: string;
}

export const CategoryPill: React.FC<CategoryPillProps> = ({
  categoryKey,
  name,
}) => {
  return (
    <Tag
      rounded="full"
      variant="outline"
      size="md"
      boxShadow="inset 0 0 0 1px var(--chakra-colors-gray-200)"
    >
      {categoryKey && (
        <Image
          src={require(`assets/images/cat/svg/${categoryKey}.svg`)}
          alt=""
          width="16px"
          height="16px"
          flexShrink={0}
          overflow="hidden"
          mx="1"
          sx={{ "user-drag": "none" }}
        />
      )}
      <TagLabel fontSize="sm" color="gray.700">
        {name}
      </TagLabel>
    </Tag>
  );
};
